import { dom, library } from "@fortawesome/fontawesome-svg-core";
import { faFacebook, faInstagram, faLinkedin, faYoutube, faTiktok } from "@fortawesome/free-brands-svg-icons";
import { faAngleDown, faGlobe, faMinus, faPlus, faTimes } from "@fortawesome/pro-regular-svg-icons";
import { faChevronCircleRight } from "@fortawesome/pro-solid-svg-icons";

library.add(
    faGlobe,
    faFacebook,
    faInstagram,
    faLinkedin,
    faYoutube,
    faTiktok,
    faAngleDown,
    faChevronCircleRight,
    faMinus,
    faPlus,
    faTimes,
);
dom.watch();
